export enum USER_TYPES {
  user = 'user',
  guest = 'guest',
  newSignup = 'newSignup',
  student = 'USER',
  teacher = 'TEACHER',
  admin = 'ADMIN'
}
